module.exports = __webpack_public_path__ + "img/36.4519db92.jpg";